import Cor from "./Cor";

export default Cor;
